import React from 'react'

export default function Forbidden() {
  return (
      <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4">
          <div class="bg-red-500 p-8 rounded-lg shadow-xl text-center w-full max-w-lg">
              <h2 class="text-4xl font-bold text-white mb-4">Access Denied</h2>
              <p class="text-xl text-white mb-6">Sorry, you don't have permission to view this page.</p>
              <a href="/" class="text-primary-500 bg-white py-2 px-6 rounded-full font-semibold text-lg shadow-md hover:bg-gray-100 transition duration-300">Go Back Home</a>
          </div>
      </div>

  )
}
